import { render, staticRenderFns } from "./previewDBXX.vue?vue&type=template&id=13d3e190&scoped=true&lang=html&"
import script from "./previewDBXX.vue?vue&type=script&lang=js&"
export * from "./previewDBXX.vue?vue&type=script&lang=js&"
import style0 from "./previewDBXX.vue?vue&type=style&index=0&id=13d3e190&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3e190",
  null
  
)

export default component.exports